/******************************************************************************************
 *	Adobe Id Email Validator
 *******************************************************************************************
 *
 * Validator for Adobe/IMS email addresses.
 * Note: The default EMAIL_REGEX does not require a TLD so a@b is a valid email address.
 *
 */

(function() {
  

  angular.module('rcDirectives.adobeidEmail', []).directive(
    'adobeidEmail',
    /* @ngInject */
    function(Utility) {
      return {
        require: 'ngModel',
        link: function(scope, elm, attrs, ctrl) {
          // The built-in email validator runs first. If the email value failed that check, value
          // will be undefined here.
          var adobeEmailValidator = function(value) {
            var isValid = Utility.isValidEmail(value);
            ctrl.$setValidity('adobeEmail', isValid);
            return isValid ? value : undefined; // undefined means no model update
          };

          ctrl.$parsers.push(adobeEmailValidator);
        }
      };
    }
  );
})();
